import { render } from "./DeclarationAcceptance.vue?vue&type=template&id=e17972ea&scoped=true&ts=true"
import script from "./DeclarationAcceptance.vue?vue&type=script&lang=ts"
export * from "./DeclarationAcceptance.vue?vue&type=script&lang=ts"

import "./DeclarationAcceptance.vue?vue&type=style&index=0&id=e17972ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e17972ea"]])

export default __exports__